
<template>
  <div :style="{direction:$t('direction')}" class="site-wrapper">

    <!-- <Header></Header> -->

    <div class="">

      <div v-if="step === 1 || step === 2" class="d-flex justify-content-center flex-column align-items-center fast-exchange" style="height:100%">

        <div class="ar-form-group">
          <label>لطفا شماره تلفن خود را وارد کنید</label>
          <the-mask :disabled="step === 2" class="ar-form-control text-center latin-input-3" :masked="true" v-model="form.mobile_number" placeholder="0 9 - - - - - - - - -" :mask="[
            '09#########'
          ]" />
          <div v-if="errors.mobile_number" class="ar-alert danger round my-2">
            <small>لطفا شماره تلفن خود را به درستی وارد نمایید.</small>
          </div>
        </div>

        <div class="pb-3 mt-2">
          <div id="rule_accept" class="text-center text-light">
            <input :disabled="step === 2" type="checkbox" id="accept" v-model="form.accept_rules">
            با <span class="highlight">قوانین و مقررات تسویه الکترونیک </span>ارزینه
            <label class="accept" for="accept">
              موافقت می کنم
            </label>
          </div>
        </div>

        <div v-if="step === 2" class="ar-form-group">
          <label>وارد کردن کد 6 رقمی</label>
          <the-mask class="ar-form-control text-center latin-input-3" :masked="true" v-model="form.code" placeholder="- - - - - -" :mask="[
            '######'
          ]" />
          <div v-if="errors.code" class="ar-alert danger round my-2">
            <small>لطفا شماره تلفن خود را به درستی وارد نمایید.</small>
          </div>
        </div>

        <div v-if="step === 1" class="text-center">
          <button v-if="!form.mobile_number || !form.accept_rules" class="ar-btn size-md round primary disabled">ارسال کد</button>
          <button v-else class="ar-btn size-md round primary" @click="SendCode()">ارسال کد</button>
        </div>

        <div v-if="step === 2" class="text-center">
          <button v-if="!form.code" class="ar-btn size-md round primary disabled">ادامه</button>
          <button v-else class="ar-btn size-md round primary" @click="VerifyCode()">ادامه</button>
        </div>

      </div>

      <div v-if="step === 3">

        <h3 class="text-light text-center pt-5">ثبت درخواست تسویه الکترونیک</h3>
        <div class="check-out-wraper">
          <div class="check-out-title">
            مشخصات متقاضی
          </div>

          <div class="check-out-body">

            <div class="form-row">

              <div class="col-12 my-2">
                <div class="ar-form-group">
                  <input class="ar-form-control text-center latin-input-3" v-model="form.name" placeholder="نام و نام خانوادگی / نام شرکت"/>
                  <div v-if="errors.name" class="ar-alert danger round my-2">
                    <small>نام و نام خانوادگی / نام شرکت اجباری است.</small>
                  </div>
                </div>
              </div>

              <div class="col-12 my-2">
                <div class="ar-form-group">
                  <input class="ar-form-control text-center latin-input-3" v-model="form.national_code" placeholder="کد ملی / شناسه ملی"/>
                  <div v-if="errors.national_code" class="ar-alert danger round my-2">
                    <small>کد ملی / شناسه ملی اجباری است.</small>
                  </div>
                </div>
              </div>

            </div>

            <div class="form-row">

              <div class="col-12 my-2">
                <div class="ar-form-group">
                  <select class="ar-form-control text-center" v-model="form.deposit_type">
                    <option hidden :value="null">نحوه واریز به ارزینه</option>
                    <option value="تتر">تتر</option>
                    <option value="ریال">ریال</option>
                    <option value="سایر">سایر</option>
                  </select>
                  <div v-if="errors.deposit_type" class="ar-alert danger round my-2">
                    <small>انتخاب نحوه واریز اجباری است.</small>
                  </div>
                </div>
              </div>

            </div>
            <div v-if="form.deposit_type" class="form-row text-light">

              <div class="col-12 my-2">
                <div class="text-center" v-if="form.deposit_type == 'تتر'">
            
                  <div>شبکه انتقال را انتخاب کنید.</div>
                  
                  <div class="buy-sell-select-networks">
                    <div v-for="(item , key) in networks" :key="key" class="select-networks-item font-en">
                      <button class="ar-btn size-lg round" :class="[admin_wallet.network === item.network ? 'primary' : 'disabled']" @click="admin_wallet = item">{{ item.network }}</button>
                    </div>
                  </div>

                  <div class="ar-form-group">
                    <label>تتر واریزی خود را بر اساس شبکه انتخاب شده به آدرس ولت زیر ارسال نمایید.</label>
                    <div class="ar-form-append">
                      <input disabled class="ar-form-control text-center font-en" v-model="admin_wallet.address">
                      <span class="ar-form-icon popover-activator" tabindex="1" @click="CopyText(admin_wallet.address)">
                        <i class="mdi mdi-content-copy"></i>
                        <span class="ar-popover">
                          کپی شد
                        </span>
                      </span>
                    </div>
                  </div>
                  
                  <div v-if="errors.wallet_address" class="ar-alert danger round my-2">
                    <small>انتخاب ولت ارزینه اجباری است.</small>
                  </div>

                </div>
                <div class="text-center" v-else>
                  <h4>مشخصات حساب ارزینه</h4>
                  <div>شماره کارت: {{ admin_bank_account.card_number }}</div>
                  <div>شماره حساب: {{ admin_bank_account.account_number }}</div>
                  <div class="mb-3">شماره شبا: {{ admin_bank_account.shaba_number }}</div>
                  
                </div>
              </div>

            </div>
            <div class="form-row">

              <div class="col-11 my-2">
                <div class="ar-form-group">
                  <select class="ar-form-control text-center" v-model="form.description">
                    <option hidden :value="null">شرح عملیات</option>
                    <option value="buy_product">بابت خرید کالا</option>
                    <option value="buy_service">بابت خرید خدمات</option>
                    <option value="checkout">بابت تسویه بدهی</option>
                    <option value="any">هیچ کدام</option>
                  </select>
                  <div v-if="errors.description" class="ar-alert danger round my-2">
                    <small>انتخاب شرح عملیات اجباری است.</small>
                  </div>
                </div>
              </div>

              <div class="col-1 my-2">
                <div class="ar-form-group mb-0 mt-1">
                  <label for="docs">
                    <input type="file" style="display:none;" id="docs" @change="docsSelected($event)">
                    <i style="color: #fff; font-size: 2rem;" class="fa fa-paperclip"></i>
                  </label>
                </div>
              </div>

              <div v-if="doc_file" class="text-center text-light my-2 col-12">
                <h4>فایل انتخابی</h4>
                {{ doc_file.name }}
              </div>

            </div>

            <div class="form-row">

              <div class="col-12 my-2">
                <div class="ar-form-group">
                  <input class="ar-form-control text-center latin-input-3" v-model="form.account_data" placeholder="اطلاعات حساب متقاضی"/>
                  <div v-if="errors.account_data" class="ar-alert danger round my-2">
                    <small>اطلاعات حساب متقاضی اجباری است.</small>
                  </div>
                </div>
              </div>

            </div>

            <div class="form-row justify-content-center">

              <div class="col-12 my-2">
                <div class="ar-form-group">
                  <the-mask class="ar-form-control text-center latin-input-3" :masked="true" @input.native="calcAmounts" v-model="form.amount" placeholder="مبلغ" :mask="[
                    '############################'
                  ]" />
                  <div v-if="errors.amount" class="ar-alert danger round my-2">
                    <small>مبلغ اجباری است.</small>
                  </div>
                </div>
              </div>

            </div>
            <div class="form-row justify-content-center">

              <div class="col-12 my-2">
                <div class="ar-form-group">
                  <input disabled class="ar-form-control text-center latin-input-3" v-model="form.porsant" placeholder="کارمزد (1.5 درصد)"/>
                </div>
              </div>

            </div>
            <div class="form-row justify-content-center">

              <div class="col-12 my-2">
                <div class="ar-form-group">
                  <input disabled class="ar-form-control text-center latin-input-3" v-model="form.total" placeholder="جمع کل"/>
                </div>
              </div>

            </div>
            
          </div>

          <div class="check-out-title">
            مشخصات بستانکار
          </div>

          <div class="check-out-body">

            <div class="form-row">

              <div class="col-12 my-2">
                <div class="ar-form-group">
                  <input class="ar-form-control text-center latin-input-3" v-model="form.creditor_name" placeholder="نام و نام خانوادگی / نام شرکت"/>
                  <div v-if="errors.name" class="ar-alert danger round my-2">
                    <small>نام و نام خانوادگی / نام شرکت اجباری است.</small>
                  </div>
                </div>
              </div>

              <div class="col-12 my-2">
                <div class="ar-form-group">
                  <input class="ar-form-control text-center latin-input-3" v-model="form.creditor_national_code" placeholder="کد ملی / شناسه ملی"/>
                  <div v-if="errors.national_code" class="ar-alert danger round my-2">
                    <small>کد ملی / شناسه ملی اجباری است.</small>
                  </div>
                </div>
              </div>

            </div>

            <div class="form-row">

              <div class="col-12 my-2">
                <div class="ar-form-group">
                  <select class="ar-form-control text-center" v-model="form.creditor_checkout_type">
                    <option hidden :value="null">نحوه تسویه بدهی</option>
                    <option value="تتر">تتر</option>
                    <option value="ریال">ریال</option>
                    <option value="سایر">سایر</option>
                  </select>
                  <div v-if="errors.creditor_checkout_type" class="ar-alert danger round my-2">
                    <small>انتخاب نحوه تسویه اجباری است.</small>
                  </div>
                </div>
              </div>

            </div>

            <div v-if="form.creditor_checkout_type" class="form-row">

              <div v-if="form.creditor_checkout_type == 'تتر'" class="col-12 my-2">
                <div class="ar-form-group">
                  <input class="ar-form-control text-center latin-input-3" v-model="form.creditor_wallet_data" placeholder="اطلاعات ولت بستانکار"/>
                  <div v-if="errors.creditor_wallet_data" class="ar-alert danger round my-2">
                    <small>اطلاعات ولت بستانکار اجباری است.</small>
                  </div>
                </div>
              </div>
              <div v-else class="col-12 my-2">
                <div class="ar-form-group">
                  <input class="ar-form-control text-center latin-input-3" v-model="form.creditor_account_data" placeholder="اطلاعات حساب بستانکار"/>
                  <div v-if="errors.creditor_account_data" class="ar-alert danger round my-2">
                    <small>اطلاعات حساب بستانکار اجباری است.</small>
                  </div>
                </div>
              </div>

            </div>
            
          </div>
        </div>
          

        <div class="text-center mb-5">
          <button @click="submitElectronicCheckoutReq()" class="ar-btn size-md mb-5 round primary">ثبت درخواست</button>
        </div>

      </div>
      
      <div v-if="step === 4" class="text-light text-center mb-5 py-5">

        <div style="font-size:10rem">
          <i class="mdi mdi-check-circle"></i>
        </div>
        <h4 class="pb-5">
        درخواست شما با موفقیت ثبت شد.
        </h4>
        <router-link :to="{name:'Home'}" class="ar-btn size-lg round primary mb-5">برگشت به صفحه اصلی</router-link>
      </div>
      
    </div>
    <Footer></Footer>
    
    <Modal :open="rules_modal" @close="rules_modal = false">
      
    </Modal>

  </div>
</template>
<script>
import Header from './Header'
import Footer from './Footer'
import Modal from '../components/Modal.vue'
import {TheMask} from 'vue-the-mask'
export default {
  name: 'Checkout',
  components:{
    Modal,
    Header,
    Footer,
    TheMask
  },
  data : () => ({
    form : {
      deposit_type:null,
      checkout_type:null,
      creditor_checkout_type:null,
      description:null,
    },
    errors : {},
    admin_bank_account : {},
    networks : [],
    admin_wallet:{},
    step:1,
    rules_modal:false,
    doc_file:null,
    errorMessage:null,
  }),
  methods: {
    CopyText(text){
      navigator.clipboard.writeText(text);
    },
    calcAmounts(){
      if(this.form.amount && this.form.amount > 0)
      {
        this.form.porsant = (this.form.amount * 1.5) / 100

        this.form.total = parseFloat(this.form.porsant) + parseFloat(this.form.amount)
      }else{
        this.form.porsant = null
        this.form.total = null
      }
    },
    docsSelected(event){
      this.doc_file = event.target.files[0];
    },
    SendCode(){
      this.activeLoading(true)
      this.form.from = 'site'
      this.form.type = 'checkout'
      this.$axios.post(`sendVerifyCode` , this.form)
      .then(res => {
        this.step = 2
        this.activeLoading(false)
      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.errors = error.errors
        }
        this.activeLoading(false)
      });
    },
    VerifyCode(){
      this.activeLoading(true)
      this.$axios.post(`checkCode` , this.form)
      .then(res => {
        this.step = 3
        this.activeLoading(false)
      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.errors = error.errors
        }
        this.activeLoading(false)
      });
    },
    checkRegistration (){
      this.activeLoading(true)
      this.$axios.post(`check_is_registered` , this.form)
      .then( res => {
        if(res.data.data !== 0){
          this.user_data = res.data.data
          this.is_registerd = true
        }
        this.activeLoading(false)
        this.step = 2;
      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.errors = error.errors
        }
        this.activeLoading(false)
      });
    },
    submitElectronicCheckoutReq (){
      this.activeLoading(true)
      this.errors = {}

      if(this.form.deposit_type == 'تتر'){
        this.form.wallet_address = this.admin_wallet.address
        this.form.wallet_network = this.admin_wallet.network
      }else{
        this.form.admin_bank_account_id = this.admin_bank_account.id
      }

      this.$axios.post(`electronicCheckout` , this.form)
      .then( () => {
        this.step = 4
        this.activeLoading(false)
      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.errors = error.errors
        }
        this.activeLoading(false)
      });
    },
    getAdminAccount(){
      this.errors = {}
      const api_token = this.getToken()
      this.$axios.post(`getAdminAccount` , {amount:0},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.admin_bank_account = res.data.data
      })
      .catch(() => {
      });

    },
    getNetworks (symbol){
      this.$axios.post(`getNetworks` , {symbol:symbol})
      .then(res => {
        this.networks = res.data.data
      })
      .catch( () => {
      });
    },
    checkCodeMeli(code)
    {
      var L=code.length;
    
      if(L<8 || parseInt(code,10)==0) return false;
      code=('0000'+code).substr(L+4-10);
      if(parseInt(code.substr(3,6),10)==0) return false;
      var c=parseInt(code.substr(9,1),10);
      var s=0;
      for(var i=0;i<9;i++)
        s+=parseInt(code.substr(i,1),10)*(10-i);
        s=s%11;
      return (s<2 && c==s) || (s>=2 && c==(11-s));
      return true;
    }
  },
  mounted() {
    this.activeLoading(false)
    this.getNetworks('USDT')
    this.getAdminAccount()
  }
}
</script>